import React from 'react';
import { Route } from 'react-router';
import { Switch } from "react-router-dom";
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import { history } from '../../configureStore'
import TaskMenu from "./menu"
import LoginForm from '../login/components/loginForm'

import 'semantic-ui-less/semantic.less'
import '../../semantic-ui/site/globals/global.css'

const App = ({ store }) => (
  <Provider store={store}>
    <ConnectedRouter history={history} >
      <Switch>
        <Route path="/login">
          <LoginForm />
        </Route>
        <Route path="/">
          <TaskMenu />
        </Route>
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default App;

